import './tuxedoSelector.css'
import more_options_icon from '../../assets/icon/more_options.svg'
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';

function TuxedoSelector({Tuxedo, sel, getStyleImg, isMobile, setLoad, setSelectStyleItem}) {

     const onItemClick = (item)=>{
        let obj = {...sel};
        obj["tuxedo"] = {...item}
        setLoad(true)
                
        getStyleImg(obj)
    
    }

    return ( 
    <div className="tuxedoSelector">
        {Tuxedo && Tuxedo.length >0 &&
        <div className="tuxedoSelector_item_row">
            <Tooltip TransitionComponent={Zoom} title={`Tuxedo : ${Tuxedo[0].name}`} > 
            <div className="tuxedoSelector_item"
                onClick={()=>{ onItemClick(Tuxedo[0])}}
            >
                <div><img src={Tuxedo[0].src}/></div>
                {/* <label className="txt-font1">{Tuxedo[0].name}</label> */}
            </div>
            </Tooltip>
            <Tooltip TransitionComponent={Zoom} title={`Tuxedo : ${Tuxedo[1] ? Tuxedo[1].name : Tuxedo[0].name}`} >
            <div className="tuxedoSelector_item"
                onClick={()=>{ onItemClick(Tuxedo[1] ? Tuxedo[1] : Tuxedo[0])}}
            >
                <div><img src={Tuxedo[1] ? Tuxedo[1].src : Tuxedo[0].src}/></div>
                {/* <label className="txt-font1">{Tuxedo[1] ? Tuxedo[1].name : Tuxedo[0].name}</label> */}
            </div>
            </Tooltip>
            <Tooltip TransitionComponent={Zoom} title={`Tuxedo : ${Tuxedo[2] ? Tuxedo[2].name : Tuxedo[0].name}`} > 
            <div className="tuxedoSelector_item"
                onClick={()=>{ onItemClick(Tuxedo[2] ? Tuxedo[2] : Tuxedo[0])}}
            >
                <div><img src={Tuxedo[2] ? Tuxedo[2].src : Tuxedo[0].src}/></div>
                {/* <label className="txt-font1">{Tuxedo[2] ? Tuxedo[2].name : Tuxedo[0].name}</label> */}
            </div>
            </Tooltip>
        </div>
        }
        <Tooltip TransitionComponent={Zoom} title="More Options" > 
        <div className="tuxedoSelector_more_options"
            onClick = {()=>{setSelectStyleItem("tuxedo")}}
        >
            <img src={more_options_icon} />
        </div>
        </Tooltip>
    </div> );
}

export default TuxedoSelector;